export default "__VITE_ASSET__D5RfHDlU__$_?url__"